import { reactNode } from '@shared/node-v1.0.0'

import { mantine } from '@nodes/mantine-v2.0.0'
import { set } from 'shared/src/libs/just'
set(window, ['R', 'libs', 'mantine'], mantine)

import v200 from '@nodes/mantine-v2.0.0'
import v210 from '@nodes/mantine-v2.1.0'

export default reactNode(
	'Mantine',
	{
		'v2.0.0': v200,
		'v2.1.0': v210,
	},
	{ allowChildren: true, docs: '' }
)
